<template>
  <div class="live-detail-home">
    <column-skeleton
      style="position: absolute;z-index: 99999;width: 100vw;height: 100vh;background: #fff"
      v-if="loading"
    ></column-skeleton>

    <div style="position: relative;top: 0;z-index: 9;background: #fff">
      <div class="ad" v-show="live.adverts_up && live.adverts_up.length > 0">
        <swiper ref="mySwiper" :options="swiperOption">
          <swiper-slide
            class="ad_logo_slide"
            v-for="(item, index) in live.adverts_up"
            :key="index"
          >
            <img class="ad_logo" :src="item.logo" alt="" />
          </swiper-slide>
        </swiper>
      </div>
      <div style="position: relative">
        <div
          id="mudu"
          class="mudu"
          :style="
            'background-image: url(' +
              live.cover_img +
              ');background-size:100% 100%;background-position:100% 100%;'
          "
        >
          <video
            :id="this.video_id"
            class="mudu video-js vjs-default-skin vjs-big-play-centered"
            controls
            preload="none"
            x5-playsinline=""
            webkit-playsinline=""
            playsinline=""
            :poster="this.live.cover_img"
            x-webkit-airplay="true"
          ></video>
          <div class="live-detail-view_count">
            <img src="/static/img/icon_live_watch.svg" alt="" />
            {{ this.live.view_count }}人观看
          </div>
        </div>
        <van-count-down
          :time="time"
          @finish="finish"
          class="live-detail-count-down"
          v-if="time > 0 && live.live_status == 0"
        >
          <template #default="timeData">
            <img
              class="time_img"
              src="/static/img/icon_live_count_down.svg"
              alt=""
            />
            <span>距离直播开始：</span>
            <span class="times">{{ timeData.days }}</span>
            <span class="time_unit">天</span>
            <span class="times">{{ timeData.hours }}</span>
            <span class="time_unit">时</span>
            <span class="times">{{ timeData.minutes }}</span>
            <span class="time_unit">分</span>
            <span class="times">{{ timeData.seconds }}</span>
            <span class="time_unit">秒</span>
          </template>
        </van-count-down>
        <div class="mudu-ready" style="background: none">
          <div
            class="mudu-reset mudu-big-play-btn"
            v-if="live.live_status == 1 && ready && live.open_status == 1"
            @click="(ready = false), (autoplay = true)"
          >
            <img src="/static/img/course/icon_course_play.svg" alt="" />
          </div>
        </div>
        <div
          class="mudu-ready"
          v-if="live.live_status == 1 && ready && live.open_status == 2"
        >
          即将开启
        </div>
        <div
          class="mudu-ready"
          v-if="live.live_status > 1 && live.live_status < 6"
        >
          直播回放正在生成中，敬请期待！
        </div>
        <div
          class="mudu-ready"
          v-if="live.live_status == 1 && !ready"
          id="mudu-ready"
        >
          <van-loading type="spinner" color="#fff" size="24px" vertical
            >加载中...</van-loading
          >
        </div>
      </div>
      <div
        class="ad"
        v-show="live.adverts_down && live.adverts_down.length > 0"
      >
        <swiper ref="mySwiper" :options="swiperOption">
          <swiper-slide
            class="ad_logo_slide"
            v-for="(item, index) in live.adverts_down"
            :key="index"
          >
            <img class="ad_logo" :src="item.logo" alt="" />
          </swiper-slide>
        </swiper>
      </div>
      <div class="live-detail-home-content">
        <van-tabs
          :swipeable="true"
          :border="true"
          v-model="tab"
          @change="scrollEnd"
        >
          <van-tab :title="'介绍'"></van-tab>
          <van-tab :title="'互动'" v-if="live.id != 958"></van-tab>
          <!--                    <van-tab :title="'相关推荐'"></van-tab>-->
          <van-tab
            :title="item.name"
            v-for="(item, index) in live.extra_content"
            :key="index + 2"
          ></van-tab>
        </van-tabs>
      </div>
      <div
        class="live-detail-home-content expert-info-content"
        @click="(showActionMeme = false), (showAction = false)"
      >
        <div v-if="tab === 0">
          <div class="live-detail-home-header" style="background: #fff">
            <div class="header-title">{{ live.title }}</div>
            <div class="header-author">{{ live.start_at_format }}</div>
          </div>

          <!-- 专家信息 start-->
          <ExpertInfo :acceptData="live.professors" />
          <!-- 专家信息 end -->

          <div class="live-detail-home-intro" v-html="live.content"></div>
        </div>
        <div v-else-if="tab === 1 && live.id != 958" class="live-detail-home-common">
          <div :class="'message ad_count_' + ad_count" ref="message">
            <van-pull-refresh
              v-model="refreshing"
              @refresh="onRefresh"
              pulling-text="加载更多"
            >
              <div
                class="message-section"
                v-for="(item, ci) in comment"
                :key="item.key"
              >
                <div class="message-section-dateline">
                  {{ item.key }}
                </div>
                <div
                  class="message-section-box"
                  v-for="(val, i) in item.comment"
                  v-if="!val.deleted"
                  :key="val.id"
                >
                  <div class="message-section-photo">
                    <img
                      @click="longTouch(i, ci)"
                      :src="
                        val.avatar == ''
                          ? '/static/bytx/web_broadcast_head.svg'
                          : val.avatar
                      "
                      alt=""
                    />
                  </div>
                  <div class="message-section-content">
                    <div class="message-section-content-author">
                      {{ val.nickname }}
                    </div>
                    <div
                      v-if="val.showBtn"
                      :class="
                        'message-section-content-btns ' +
                          (is_manager == 1 || val.user_id == user_id
                            ? 'manager'
                            : '')
                      "
                    >
                      <span @click="subscribeUser(i, ci)">@ 对方</span>
                      <span @click="subscribeAndCite(i, ci)">@ 并引用</span>
                      <span
                        @click="deleteMessage(i, ci)"
                        v-if="is_manager == 1 || val.user_id == user_id"
                        >删除</span
                      >
                    </div>
                    <div
                      @click="longTouch(i, ci)"
                      :class="
                        'message-section-content-detail ' +
                          (val.manager === 1 ? 'manager' : '')
                      "
                      v-html="
                        val.message.replace(
                          /\\x(\d{1,2})/g,
                          '<img src=&quot;https://static.mudu.tv/assets/img-console/activity/face/$1.png&quot; />'
                        )
                      "
                    ></div>
                    <div class="clear"></div>
                    <div
                      class="message-section-content-cite"
                      v-if="val.cite_content != ''"
                      v-html="val.cite_content"
                    ></div>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
              <div class="message-end"></div>
            </van-pull-refresh>
          </div>
        </div>
        <div
          v-if="tab == index + 2"
          class="live-detail-home-intro"
          v-for="(item, index) in live.extra_content"
          :key="index"
        >
          <div
            style="margin-top: 15px"
            v-html="
              item.content.replace(
                /https:\/\/img.xiumi.us/g,
                'https:\/\/byh-api.dr-gobroad.com\/xiumi\/?host=img.xiumi.us&url=https:\/\/img.xiumi.us'
              )
            "
          ></div>
        </div>
      </div>

      <div class="live-share-box" v-if="tab != 1">
        <img
          @click="openShareData"
          src="/static/bytx/detail_share_btn.svg"
          alt=""
        />
        <img
          @click="toHome"
          src="/static/bytx/detail_back_home_btn.svg"
          alt=""
        />
      </div>
      <img
        v-if="live.expert_recommend == 1 && tab != 1"
        @click="view_doctor"
        style="width:58px;height:58px;position: fixed;bottom: 80px;right: 10px;z-index: 999"
        src="https://care-yyh.com/static/bytx/detail_expert_btn.svg"
        alt=""
      />

      <!--  communContent v-model="接受的数据源" -->
      <!-- id 订单ID -->
      <!-- 新内容 start-->
      <div class="new-live-detail-home-footer" v-if="live.id != 958 && (tab === 0 || tab === 1)">
        <div
          class="new-live-detail-home-footer-content-text"
          v-if="live && live.parent && live.parent.title"
          @click="goParent(live.parent)"
        >
          <van-image
            fit="cover"
            src="/static/bytx/detail_tag_column_icon.svg"
          ></van-image>
          <div>
            {{ live.parent.title }}
          </div>
          <div><van-icon name="arrow" /></div>
        </div>
        <div class="new-live-detail-home-footer-bottom">
          <div class="new-live-detail-home-footer-bottom-left">
            <van-grid :column-num="1" :border="false">
              <van-grid-item
                icon="/static/img/live/icon_live_meme.svg"
                @click="showActionMeme = !showActionMeme"
              />
            </van-grid>
          </div>
          <div
            :class="[
              'new-live-detail-home-footer-bottom-center ',
              comment_text != '' ? 'comment_in' : ''
            ]"
          >
            <van-field
              round
              left-icon="/static/img/course/icon_course_text.svg"
              v-model="comment_text"
              :placeholder="
                comment_placeholder == '' ? '写评论…' : comment_placeholder
              "
            >
            </van-field>
          </div>
          <div class="new-live-detail-home-footer-bottom-right">
            <van-grid :column-num="3" :border="false" v-if="comment_text == ''">
              <van-grid-item
                @click="favorite()"
                v-if="!is_manager && live.isFavorite"
                icon="/static/img/course/icon_course_favorite_on_20.svg"
                text="已收藏"
              />
              <van-grid-item
                @click="favorite()"
                v-else-if="!is_manager && !live.isFavorite"
                icon="/static/bytx/collection.svg"
                text="收藏"
              />
              <van-grid-item
                @click="showDialog"
                icon="/static/bytx/Inquiries.svg"
                text="去问诊"
              />
              <van-grid-item
                @click="goWechat()"
                icon="/static/bytx/customer-service.svg"
                text="客服"
              />
              <van-grid-item
                v-if="is_manager"
                icon="/static/img/live/icon_live_more.svg"
                @click="showAction = !showAction"
                text="更多"
              />
            </van-grid>

            <div class="live-detail-home-footer-right-btn" v-if="comment_text">
              <van-button
                type="danger"
                size="medium"
                color="#0FB7AD"
                style="width:100%"
                @click="createComment"
                round
              >
                发送
              </van-button>
            </div>
          </div>
        </div>
        <div class="live-detail-home-footer-bottom" v-if="showAction">
          <van-divider />
          <van-grid :column-num="is_manager ? 3 : 2" :border="false">
            <van-grid-item
              icon="/static/img/course/icon_course_download.svg"
              text="资料下载"
              @click="showDownload = true"
            />
            <van-grid-item
              @click="favorite()"
              v-if="live.isFavorite"
              icon="/static/img/course/icon_course_favorite_on_20.svg"
              text="已收藏"
            />
            <van-grid-item
              @click="favorite()"
              v-else
              icon="/static/img/course/icon_course_favorite_off_20.svg"
              text="收藏"
            />
            <van-grid-item text="发送图片" v-if="is_manager">
              <template slot="icon">
                <van-uploader :after-read="afterRead" accept="*">
                  <img
                    width="20"
                    style="margin-bottom: 5px;margin-top: 3px"
                    src="https://dr-yyh.com/static/two/upload_img.svg"
                    alt=""
                  />
                </van-uploader>
              </template>
            </van-grid-item>
          </van-grid>
          <van-divider />
          <van-number-keyboard safe-area-inset-bottom />
        </div>
        <div class="live-detail-home-footer-bottom" v-if="showActionMeme">
          <van-divider />
          <van-grid :column-num="10" :border="false">
            <van-grid-item
              @click="choose_meme(index)"
              :icon="
                'http://static.mudu.tv/assets/img-console/activity/face/' +
                  index +
                  '.png'
              "
              v-for="index in 75"
              :key="index"
            />
          </van-grid>
          <van-divider />
          <van-number-keyboard safe-area-inset-bottom />
        </div>
      </div>
      <!-- 新内容 ent -->

      <van-dialog
        class="share"
        style="margin-top: 66px"
        v-model="showShareDialog"
        :showConfirmButton="false"
      >
        <img
          class="share-top-img"
          width="100%"
          src="/static/bytx/detail_share_title_img.png"
          alt=""
        />
        <div v-if="showShareLoading == false">
          <div class="share-img">
            <img
              :src="htmlUrl"
              style="width: 100%;border-radius: 10px;"
              v-if="htmlUrl != ''"
              alt=""
            />
          </div>
          <div
            class="share-cancel-btn"
            @click="showShareDialog = false"
            style="margin-top: 10px"
          >
            <img src="/static/img/course/icon_course_share_close.svg" alt="" />
          </div>
        </div>
        <div v-else align="center">
          <van-loading size="24px">正在生成转发图片</van-loading>
        </div>
      </van-dialog>

      <van-dialog
        class="content"
        v-model="needPassword"
        :show-confirm-button="false"
      >
        <template slot="title">
          本场直播需要您输入观看密码
        </template>
        <div class="cancel_otp_code_box">
          <div class="otpInputs">
            <input
              v-enterfocus
              ref="otpInputs"
              type="number"
              value="12"
              v-model="code"
              @keydown.delete="changeCode"
            />
            <span class="code_list">{{ code1 }}</span>
            <span class="code_list">{{ code2 }}</span>
            <span class="code_list">{{ code3 }}</span>
            <span class="code_list last_code_list">{{ code4 }}</span>
          </div>
          <p class="error_text" :class="{ show: error }">密码错误请重试</p>
        </div>
        <div class="content-footer">
          <van-button
            style="width: 50%"
            type="danger"
            round
            @click="checkPassword"
            color="#0FB7AD"
          >
            点击验证
          </van-button>
        </div>
      </van-dialog>

      <van-action-sheet v-model="showDownload" title="资料下载">
        <div class="download-cell">
          <van-cell
            title-class="download-cell__item"
            v-for="item in live.downloads"
            :key="item.link"
            :title="item.name"
            @click="download_item(item)"
            :icon="
              item.type == 'pdf'
                ? '/static/img/course/icon_course_download_pdf.svg'
                : '/static/img/course/icon_course_download_pic.svg'
            "
            icon-size="20px"
          >
            <template slot="right-icon">
              <van-icon name="/static/img/course/icon_course_download.svg" />
            </template>
          </van-cell>
        </div>
        <div class="van-action-sheet__footer" style="height: 30px">
          <div class="van-action-sheet__gap"></div>
        </div>
      </van-action-sheet>
    </div>

    <van-action-sheet
      class="scribe"
      v-model="showActionScribe"
      title="添加小助手"
    >
      <img :src="live.dialog_img == '' ? '/static/bytx/qrcode/new_scan.jpeg' : live.dialog_img" alt="" />
      <div class="scribe-title">扫码添加“「博医同行」患友助手”</div>
      <div class="scribe-desc">第一时间接收战友活动提醒</div>
      <div class="clearfix"></div>
    </van-action-sheet>

    <!-- 在线咨询  || 咨询医生 -->
    <Consult ref="Refconsult"></Consult>
    <share-data :share-data="live" @getShareImg="getShareImg"></share-data>
  </div>
</template>
<script>
import Interface from "@/util/interface";
import { formatTimeToStr } from "@/util/date";
import columnSkeleton from "@/skeleton/columnSkeleton";
import videojs from "video.js";
import verify from "../../../mixins/verify";
import comment from "../../../mixins/comment";
import { Consult } from "@/components/overlay";
import ExpertInfo from "@/components/expertInfo";
import checkLogin from "@/mixins/checkLogin";
import { LocationHref, toHomePage } from "@/util/common";
import shareData from "@/components/shareData/index";
import wx from "weixin-js-sdk";
import item from "../../doctor-details/item.vue";

export default {
  name: "live-detail-home",
  computed: {
    item() {
      return item
    }
  },
  mixins: [verify, comment, checkLogin],
  components: {
    "column-skeleton": columnSkeleton,
    Consult,
    ExpertInfo,
    shareData
    // Communication
  },
  data() {
    return {
      //新的收入框接受内容
      communContent: "",
      appid: "gh_2af07dce0869",
      doctor_path:
        "pages/doctorModule/doctorList/index.html?routerName=expertList",
      id: "",
      course: {},
      downloads: [],
      related: [],
      value: "",
      active: "",
      live: {},
      textMessage: "",
      player: "",
      viewNum: 0,
      tab: 0,
      loading: true,
      ready: true,
      video_url: "",
      share_data: {},
      showShareDialog: false,
      showShareLoading: false,
      htmlUrl: "",
      isShow: false,
      status: "",
      time: 0,
      user: {},
      showDownload: false,
      showAction: false,
      checkLogin: false,
      showActionMeme: false,
      myPlayer: "",
      showActionScribe: true,
      swiperOption: {
        loop: false,
        autoplay: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        centerInsufficientSlides: true
      },
      interval: "",
      current: 0,
      busy: false,
      autoplay: false,
      live_manager_avatar: [],
      video_id: "",
      open_status: 2,
      increase: 1,
      refreshing: false,

      ad_count: 0,
      recommendLoading: false,
      recommendFinished: true,
      recommendSsLoading: false,
      listItem: [],
      parentInfo: {},
      contentType: 0,
      pageType: 1
    };
  },
  filters: {
    formatDate: function(time) {
      return formatTimeToStr(time * 1000, "MM月dd日 hh:mm");
    }
  },
  methods: {
    goParent(row) {
      this.$router.push({ name: "live-column", params: { id: row.id } });
    },
    goWechat() {
      LocationHref("https://work.weixin.qq.com/kfid/kfc80e2e65a20c7e4b8");
    },
    onRefresh() {
      this.refreshing = false;
    },
    showDialog() {
      this.$refs.Refconsult.overlayShow = true;
    },
    fetch(scene) {
      if (scene === "live") {
        let params = {
          increase: this.increase
        };
        Interface.getData(
          "get",
          Interface.live.detail + "/" + this.id,
          params
        ).then(res => {
          if (res.code == 0) {
            this.live = res.data.live;
            document.title = this.live.title;
            Interface.mFootPrint(this.id, 4, 3, 1, 0, 0, 0, this.live.title);
            let dom = document.getElementById("mudu");
            if (this.live.live_status < 6) {
              dom.innerHTML =
                '<div id="' +
                this.video_id +
                '" class="mudu"></div><div class="live-detail-view_count"><img src="/static/img/icon_live_watch.svg" alt="">' +
                this.live.view_count +
                "人观看</div>";
            } else {
              setTimeout(() => {
                this.initVideo();
              }, 300);
            }
            setTimeout(() => {
              this.initMudu();
              this.loading = false;
            }, 300);

            if (this.live.need_password === 1 && !this.live.isPasswordAuth) {
              this.needPassword = true;
            }

            let _user = localStorage.getItem("user");
            this.user = JSON.parse(_user);

            if (this.live.live_manager && this.live.live_manager.length > 0) {
              this.live.live_manager.forEach(val => {
                this.live_manager_avatar.push(val.id);
                if (this.user.id === val.id) {
                  this.is_manager = 1;
                }
              });
            } else {
              this.live_manager_avatar = [];
            }

            this.time = this.live.limit_time;
            if (this.live.subscribe_notice === 1 && !this.live.isNotice) {
              this.showActionScribe = true;
            }

            if (this.live.downloads != null && this.live.downloads.length > 0) {
              this.live.downloads.forEach(item => {
                if (item.link) {
                  item.type = item.link.substr(item.link.length - 3, 3);
                }
              });
            } else {
              this.live.downloads = [];
            }

            this.ad_count = 0;
            if (this.live.adverts_up && this.live.adverts_up.length > 0) {
              this.ad_count += 1;
            }
            if (this.live.adverts_down && this.live.adverts_down.length > 0) {
              this.ad_count += 1;
            }
            localStorage.setItem("live_dialog_img", this.live.dialog_img);

            this.fetch("subscribe");
            this.intervalCheck();
            this.getComment();
            this.fetch("live_record");
            this.increase = 2;
            this.setWechatShare();
          } else {
            this.loading = false;
            this.$toast.fail(res.message);
          }
        });
      } else if (scene === "live_record") {
        let params = {
          content_id: this.id,
          type: 4,
          randStr: this.video_id
        };
        Interface.getData("get", Interface.live.record, params);
      } else if (scene === "subscribe") {
        Interface.getData(
          "get",
          Interface.live.subscribeItem + this.id
        ).then(res => {});
      }
    },
    view_doctor() {
      LocationHref(
        "https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=expert"
      );
    },
    getViewCount() {
      Interface.getData("get", Interface.live.view_count + "/" + this.id).then(
        res => {
          if (res && res.code == 0) {
            this.open_status = res.data.open_status;
            this.live.live_count = res.data.view_count;

            let countEl = document.getElementsByClassName(
              "live-detail-view_count"
            );
            if (countEl && countEl.length > 0) {
              countEl[0].innerHTML = res.data.view_count + "人观看";
            }

            if (
              res.data.open_status == 1 &&
              this.live.live_status == 0 &&
              res.data.live_status == 1
            ) {
              setTimeout(() => {
                this.fetch("live_record");
                if (Mudu) {
                  Mudu.Destroy();
                }
                if (this.interval != "") {
                  clearInterval(this.interval);
                }
                this.video_id = "J_prismPlayer" + this.randomNum(1111, 9999);
                this.fetch("live");
              }, 3000);
            } else if (
              res.data.open_status == 1 &&
              this.live.live_status == 1 &&
              this.live.open_status == 2
            ) {
              setTimeout(() => {
                this.fetch("live_record");
                if (Mudu) {
                  Mudu.Destroy();
                }
                if (this.interval != "") {
                  clearInterval(this.interval);
                }
                this.video_id = "J_prismPlayer" + this.randomNum(1111, 9999);
                this.fetch("live");
              }, 3000);
            } else if (
              res.data.open_status == 2 &&
              this.live.live_status == 1 &&
              this.live.open_status == 1
            ) {
              setTimeout(() => {
                this.fetch("live_record");
                if (Mudu) {
                  Mudu.Destroy();
                }
                if (this.interval != "") {
                  clearInterval(this.interval);
                }
                this.video_id = "J_prismPlayer" + this.randomNum(1111, 9999);
                this.fetch("live");
              }, 3000);
            } else if (
              res.data.live_status == 1 &&
              this.live.live_status == 2
            ) {
              setTimeout(() => {
                sessionStorage.removeItem("first_mount");
                window.location.reload();
              }, 3000);
            }
          }
        }
      );
    },
    initVideo() {
      let _this = this;
      Interface.getData(
        "get",
        Interface.video_info + "/" + _this.live.video_id
      ).then(resp => {
        let videoUrl;
        resp.data.PlayInfoList.PlayInfo.forEach(val => {
          if (val.Format == "mp4") {
            videoUrl = val.PlayURL;
          }
        });
        const myPlayerOptions = {
          bigPlayButton: true,
          textTrackDisplay: true,
          posterImage: true,
          errorDisplay: true,
          controlBar: true,
          autoplay: false,
          controls: true
        };
        this.course_img_visible = false;
        setTimeout(() => {
          this.myPlayer = videojs(
            this.video_id,
            myPlayerOptions,
            function onPlayerReady() {
              this.on("play", function() {
                //检测登录
                let user = localStorage.getItem("user");
                user = JSON.parse(user);
                if (_this.live.need_auth == 1 && user.new_reg_complete !== 1) {
                  this.pause();
                  _this.showAddConfirm("live");
                }
                Interface.mFootPrint(
                  _this.id,
                  96,
                  _this.contentType,
                  _this.pageType,
                  0,
                  0,
                  0,
                  _this.live.title
                );
              });
            }
          );
          this.myPlayer.src(videoUrl);
          this.myPlayer.poster(_this.live.cover_img);
          this.myPlayer.load(videoUrl);
          this.loading = false;
          setTimeout(() => {
            this.ready = true;
          }, 300);
        }, 300);
      });
    },
    initMudu() {
      let _this = this;
      if (_this.live.webinar_id === 0) {
        return false;
      }

      window.Mudu.Init(
        // 频道id
        _this.live.webinar_id,
        // 初始化完成的回调函数，无参数
        function() {
          let user = localStorage.getItem("user");
          user = JSON.parse(user);
          let name = user.nick_name == "" ? "匿名用户" : user.nick_name;
          let avatar = user.avatar == "" ? "." : user.avatar;
          let id = user.id == 0 ? "0" : user.id;
          window.Mudu.Room.User.Assign(name, avatar, id, () => {});
          //建立websocket
          window.Mudu.MsgBus.On("Comment.New", function() {
            setTimeout(() => {
              _this.getComment();
            }, 500);
          });

          Mudu.MsgBus.On("Room.StreamEvent", function(data) {
            setTimeout(() => {
              _this.fetch("live_record");
              if (Mudu) {
                Mudu.Destroy();
              }
              if (_this.interval != "") {
                clearInterval(_this.interval);
              }
              _this.video_id = "J_prismPlayer" + _this.randomNum(1111, 9999);
              _this.fetch("live");
            }, 3000);
          });

          if (_this.live.live_status === 1 && _this.live.open_status === 1) {
            new Mudu.Player({
              containerId: _this.video_id,
              isLive: !!Mudu.Room.GetLiveStatus(),
              src: Mudu.Room.GetPlayAddrList(),
              image: _this.live.cover_img,
              autoplay: _this.autoplay,
              controls: true,
              repeat: false,
              width: "100%",
              height: "100%",
              x5Layer: false,
              x5Inline: false
            });

            Mudu.MsgBus.On("Player.Play", function(player) {
              if (_this.checkLogin) {
                return;
              }
              if (_this.live.need_auth == 1) {
                //检测登录
                let user = localStorage.getItem("user");
                user = JSON.parse(user);
                if (user.new_reg_complete !== 1) {
                  player.stop();
                  _this.showAddConfirm("live");
                }
              }
            });

            //更改loading状态
            Mudu.MsgBus.On("Player.Ready", function(player) {
              _this.ready = true;
            });
            _this.ready = true;

            Mudu.MsgBus.On("Room.StreamEvent", function(data) {
              var msg = data.event == 1 ? "开始直播" : "停止直播";
              setTimeout(() => {
                if (data.event != 1) {
                  _this.fetch("live_record");
                  if (Mudu) {
                    Mudu.Destroy();
                  }
                  if (_this.interval != "") {
                    clearInterval(_this.interval);
                  }
                  _this.video_id =
                    "J_prismPlayer" + _this.randomNum(1111, 9999);
                  _this.fetch("live");
                }
              }, 3000);
            });
          }
        }
      );
    },
    scrollEnd() {
      if (this.tab == 1) {
        setTimeout(() => {
          let scrollDom = this.$refs.message;
          scrollDom.scroll({ top: 5000000, left: 0, behavior: "smooth" });
        }, 300);
      }
      this.$forceUpdate();
    },
    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
        default:
          return 0;
      }
    },
    openShareData() {
      // let params = {
      //     content_id: this.id,
      //     type: 4
      // }
      // this.showShareLoading = true
      // this.showShareDialog = true
      // Interface.getData('get', Interface.share, params).then(res => {
      //     this.htmlUrl = res.data.post_img_url
      //     this.showShareLoading = false
      // })
      this.showShareDialog = true;
    },
    getShareImg(url) {
      this.htmlUrl = url;
    },
    favorite() {
      Interface.getData("get", Interface.live.favorite + this.id).then(res => {
        if (res.code == 0) {
          this.live.isFavorite = !this.live.isFavorite;
        }
      });
    },
    toHome() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        if (localStorage.getItem("isMini") == 1) {
          wx.closeWindow(); // 关闭网页
          wx.miniProgram.reLaunch({ url: "/pages/home/index" });
        } else {
          window.location.href =
            "https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=bytx-home";
        }
      } else {
        toHomePage();
      }
    },
    download_item(item) {
      let user = localStorage.getItem("user");
      user = JSON.parse(user);

      if (_this.live.need_auth == 1) {
        //检测登录
        let user = localStorage.getItem("user");
        user = JSON.parse(user);
        if (user.new_reg_complete !== 1) {
          this.pause();
          this.showAddConfirm("live");
        }
      }
      LocationHref(item.url);
    },
    finish() {
      if (this.live.live_status == 0) {
        this.fetch("live");
      }
    },
    intervalCheck() {
      if (this.interval != "") {
        clearInterval(this.interval);
      }
      try {
        this.interval = setInterval(() => {
          this.getViewCount();
          this.fetch("live_record");
        }, 6000);
      } catch (e) {}
    },
    in_array(search, array) {
      if (array != null && array.length > 0) {
        for (let i in array) {
          if (array[i] == search) {
            return true;
          }
        }
      }
      return false;
    },
    setWechatShare() {
      let desc = "点击观看直播";

      if (this.live.live_status == 6) {
        desc = "点击观看直播回放";
      }

      if (this.live.id > 230 && this.live.id < 235) {
        desc = "高博造血干细胞移植系列科普直播，快 “戳”进来观看~";
      }

      Interface.getShareInfo(this, this.live.title, this.live.cover_img, desc);
    }
  },
  created() {
    let first_mount = sessionStorage.getItem("first_mount");
    sessionStorage.setItem("complete_from", "live");
    if (first_mount == "1") {
      sessionStorage.removeItem("first_mount");
      window.location.reload(); //keep-alive 不好使
    } else {
      sessionStorage.setItem("first_mount", 1);
    }
    this.id = this.$route.params.id;
    this.contentType = sessionStorage.getItem("contentType");
    this.pageType = sessionStorage.getItem("pageType");
    let _user = localStorage.getItem("user");
    this.user = JSON.parse(_user);
    this.user_id = this.user.id;
    this.video_id = "J_prismPlayer" + this.randomNum(1111, 9999);
    this.fetch("live");
  },
  beforeDestroy() {
    this.fetch("live_record");
    if (this.myPlayer) {
      this.myPlayer.dispose();
    }
    if (Mudu) {
      Mudu.Destroy();
    }
    if (this.interval != "") {
      clearInterval(this.interval);
    }
  },
  watch: {
    "$route.params.id": {
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          // this.fetch('live')
        }
      }
    }
  }
};
</script>
<style lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/live/detail_home/index.vue